module.exports = "pegasus_template/assets/email1-view-online-icon.png";